var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conditions"},[_c('h2',{staticClass:"conditions__title"},[_vm._v("Condizioni principali")]),_c('circle-list',{attrs:{"items":_vm.conditions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }